import React from "react";
import { TextField, MenuItem, FormControl } from "@material-ui/core";

const ApiKeyField = ({ values, touched, errors, setFieldValue, apiKeysList, label }) => (
  <FormControl fullWidth margin="dense" variant="outlined">
    <TextField
      select
      label={label}
      name="apiKey"
      value={values.apiKey || ""}
      onChange={(e) => setFieldValue("apiKey", e.target.value)}
      error={touched.apiKey && Boolean(errors.apiKey)}
      helperText={touched.apiKey && errors.apiKey}
      variant="outlined"
    >
      {apiKeysList?.map((key) => (
        <MenuItem key={key.id} value={key.id}>
          {`${key.name} || ${key.key}`}
        </MenuItem>
      ))}
    </TextField>
  </FormControl>
);

export default ApiKeyField;
